var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroup3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.986,
    height: 20,
    viewBox: "0 0 19.986 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3",
    transform: "translate(533.416 -110.358)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3562",
    "data-name": "Path 3562",
    d: "M-533.839,110.358a8.013,8.013,0,0,1,7.515,6.15,7.9,7.9,0,0,1-.906,6.222c-.068.114-.1.188.015.305,1.406,1.4,2.793,2.81,4.212,4.191a1.714,1.714,0,0,1,.51,1.756,1.71,1.71,0,0,1-1.331,1.319,1.728,1.728,0,0,1-1.724-.523l-4.036-4.036c-.288-.288-.288-.288-.63-.09a8.177,8.177,0,0,1-10.481-2.067,8.083,8.083,0,0,1-1.708-5.541,8.127,8.127,0,0,1,5.676-7.3A9.251,9.251,0,0,1-533.839,110.358Zm-.409,3.645a4.478,4.478,0,0,0-4.534,4.55,4.492,4.492,0,0,0,4.555,4.535,4.506,4.506,0,0,0,4.529-4.545A4.492,4.492,0,0,0-534.247,114Z",
    transform: "translate(9)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup3);
export default __webpack_public_path__ + "static/media/Group 3.d9657c7c3a3d03a2b8ff6641a6097377.svg";
export { ForwardRef as ReactComponent };